import React, { useRef, useEffect } from "react";
import { MenuList, Box } from "@mui/material";
import Popover from "@mui/material/Popover";
import { Button } from "../button/Buttons.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import "../../localization/MessageLocalizer.js";
import "../../localization/LocaleProvider.js";
import { sharedLocalization } from "../../localization/sharedResources.js";
import { useDropdownClasses, useDropdownStyle } from "./DropdownHoc.style.js";
var DropdownType = /* @__PURE__ */ ((DropdownType2) => {
  DropdownType2["Separated"] = "Separated";
  DropdownType2["Attached"] = "Attached";
  return DropdownType2;
})(DropdownType || {});
const withDropdown = (WrappedComponent) => (props) => {
  const { classes, cx } = useDropdownClasses();
  const {
    buttonContent,
    container,
    anchorOrigin,
    transformOrigin,
    listTitle,
    children,
    closeOnClickInside,
    closeOnClickOutside,
    applyAction,
    applyActionContent,
    actionsFullWidth = true,
    isApplyDisabled,
    cancelAction,
    onApplyClick,
    onCancelClick,
    onOutsideClick,
    onDropdownOpen,
    onDropdownClose,
    styles,
    hasMenuList = true,
    dropdownType = "Separated",
    className,
    fitDropdownToContent = false,
    dropdownListNoMinWidth = false,
    reverseActionsOrder = false,
    renderInsideInputConteiner = true,
    ...otherProps
  } = props;
  const containerRef = useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const defaultDropdownStyles = useDropdownStyle(dropdownType);
  const computedDropdownStyles = { ...defaultDropdownStyles, ...styles };
  const handleDropdownActionClick = (event) => {
    setAnchorEl(event.currentTarget);
    stopEvent(event);
  };
  const stopEvent = (e) => {
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickInside = () => {
    if (closeOnClickInside !== false) {
      handleClose();
    }
  };
  useEffect(() => {
    if (onDropdownOpen && onDropdownClose) {
      if (open) {
        onDropdownOpen();
      } else {
        onDropdownClose();
      }
    }
  }, [open]);
  const handleApplyClick = () => {
    handleClose();
    if (onApplyClick) {
      onApplyClick();
    }
  };
  const handleCancelClick = () => {
    handleClose();
    if (onCancelClick) {
      onCancelClick();
    }
  };
  const handleClickOutside = (event) => {
    if (closeOnClickOutside !== false) {
      handleClose();
    }
    if (onOutsideClick) {
      onOutsideClick();
    }
    stopEvent(event);
  };
  const handleClick = (event) => {
    stopEvent(event);
  };
  const cancleActionNode = cancelAction ? /* @__PURE__ */ React.createElement(
    Button,
    {
      "data-testid": "cancelAction",
      onClick: handleCancelClick,
      className: cx(classes.dropdownAction, {
        [classes.dropdownActionUnsetWidth]: !actionsFullWidth
      })
    },
    /* @__PURE__ */ React.createElement(LocalizedText, { label: cancelAction === true ? sharedLocalization.cancel : cancelAction })
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null);
  const applyActionNode = applyAction ? /* @__PURE__ */ React.createElement(
    Button,
    {
      "data-testid": "applyAction",
      color: "primary",
      onClick: handleApplyClick,
      className: cx(classes.dropdownAction, {
        [classes.dropdownActionUnsetWidth]: !actionsFullWidth
      }),
      disabled: isApplyDisabled,
      label: applyAction === true ? sharedLocalization.apply : applyAction
    },
    applyActionContent
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { ref: containerRef }, /* @__PURE__ */ React.createElement(
    WrappedComponent,
    {
      ...otherProps,
      onClick: handleDropdownActionClick,
      className: cx(
        computedDropdownStyles?.dropdownButton,
        {
          [computedDropdownStyles?.dropdownButtonOpen]: open
        },
        className
      )
    },
    buttonContent
  )), /* @__PURE__ */ React.createElement(
    Popover,
    {
      "data-testid": "dropdownPopover",
      open,
      anchorEl,
      anchorOrigin: anchorOrigin ?? {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: transformOrigin ?? {
        vertical: "top",
        horizontal: "right"
      },
      onClose: handleClickOutside,
      disableRestoreFocus: true,
      classes: { root: computedDropdownStyles?.dropdownRoot, paper: computedDropdownStyles?.dropdownPaper },
      container: container ?? (renderInsideInputConteiner ? containerRef.current : void 0),
      onClick: handleClick
    },
    hasMenuList ? /* @__PURE__ */ React.createElement(
      MenuList,
      {
        className: cx(
          fitDropdownToContent ? classes.dropdownListNoPadding : "",
          classes.dropdownList,
          computedDropdownStyles?.dropdownContainer,
          dropdownListNoMinWidth ? classes.dropdownListNoMinWidth : ""
        )
      },
      listTitle ? /* @__PURE__ */ React.createElement(Box, { className: classes.dropdownListTitle }, /* @__PURE__ */ React.createElement(LocalizedText, { label: listTitle })) : null,
      /* @__PURE__ */ React.createElement("div", { onClick: handleClickInside }, children),
      applyAction || cancelAction ? /* @__PURE__ */ React.createElement(Box, { className: cx(classes.dropdownActions, computedDropdownStyles?.dropdownActions) }, reverseActionsOrder ? [applyActionNode, cancleActionNode] : [cancleActionNode, applyActionNode]) : null
    ) : /* @__PURE__ */ React.createElement("div", { className: classes.dropdownContent, onClick: handleClickInside }, children)
  ));
};
export {
  DropdownType,
  withDropdown
};
//# sourceMappingURL=DropdownHoc.js.map
